import { IRootState } from "../../store/rootState";

/*
 * Default data passed with every tracking event
 */
export const getDefaultData = (reduxState: IRootState) => {
  // Add default tracking data here (example: from redux or apollo cache) //

  const s = reduxState?.analyticsManager?.userIdentifier ?? {};
  // eslint-disable-next-line camelcase
  const { institution_id, institution_name, location_id, location_name } = s;
  return { institution_id, institution_name, location_id, location_name };
};

export const getDateTimeStringInEst = (date: Date) =>
  date.toLocaleString("en-US", {
    timeZone: "EST",
    timeZoneName: "short",
  });

/**
 * @param startTime
 * @param endTime
 * @returns difference between startTime and endTime in seconds
 */
export const getTimeSpentInSeconds = (startTime: Date, endTime: Date) => {
  return startTime && endTime
    ? Math.round((endTime.getTime() - startTime.getTime()) / 1000)
    : 0;
};
